import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface TooltipProps {
  top: number;
  left: number;
}

function Tooltip({top, left}: TooltipProps): JSX.Element {
  return (
    <div style={{display: 'block', top, left}} className="tooltip fade top in">
      <div className="tooltip-arrow" />
      <div className="tooltip-inner" />
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<TooltipProps>(Tooltip);
